import { combineReducers } from 'redux';

import flashMessageReducer from './flashMessage';

// API Reducers
import { curriculums } from '../../services/curriculums';
import { languages } from '../../services/languages';
import { users } from '../../services/users';
import { profile } from '../../services/profile';
import { shortUrl } from '../../services/shortUrl';
import { organizations } from '../../services/organizations';
import { response } from '../../services/response';
import { payment } from '../../services/payments';
import { products } from '../../services/products';
import { productEvents } from '../../services/productEvents';
import { signedUrl } from '../../services/signedUrl';
import { questionnaire } from '../../services/questionnaire';
import { lessons } from '../../services/lessons';
import { subjects } from '../../services/subjects';
// AUTH
import { authentication } from '../../services/authentication';
// SEO Cotent
import { seoContent } from '../../services/seoContent';

import subjectReducer from './subject';
import planReducer from './plan';

export default combineReducers({
  flashMessageReducer: flashMessageReducer as any,
  subjectReducer: subjectReducer as any,
  planReducer: planReducer as any,

  // API
  [curriculums.reducerPath]: curriculums.reducer,
  [languages.reducerPath]: languages.reducer,
  [users.reducerPath]: users.reducer,
  [profile.reducerPath]: profile.reducer,
  [shortUrl.reducerPath]: shortUrl.reducer,
  [organizations.reducerPath]: organizations.reducer,
  [response.reducerPath]: response.reducer,
  [payment.reducerPath]: payment.reducer,
  [products.reducerPath]: products.reducer,
  [productEvents.reducerPath]: productEvents.reducer,
  [signedUrl.reducerPath]: signedUrl.reducer,
  [questionnaire.reducerPath]: questionnaire.reducer,
  [lessons.reducerPath]: lessons.reducer,
  [subjects.reducerPath]: subjects.reducer,
  // AUTH
  [authentication.reducerPath]: authentication.reducer,
  // SEO Cotent
  [seoContent.reducerPath]: seoContent.reducer,
});
